function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 24,
  height: 25.1708,
  rx: 3.5,
  fill: "#FFFF66",
  stroke: "#FF7D05"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1104 13.8493L20.1104 13.0854L4.88997 13.0854L4.88997 13.8493C4.88996 15.8751 5.69175 17.818 7.11894 19.2504C8.54613 20.6829 10.4818 21.4877 12.5002 21.4877C14.5185 21.4877 16.4542 20.6829 17.8814 19.2504C19.3086 17.818 20.1104 15.8751 20.1104 13.8493Z",
  fill: "#FF7D05"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7749 9.77224C19.5098 9.77224 20.1055 9.17652 20.1055 8.44166C20.1055 7.7068 19.5098 7.11108 18.7749 7.11108C18.0401 7.11108 17.4443 7.7068 17.4443 8.44166C17.4443 9.17652 18.0401 9.77224 18.7749 9.77224Z",
  fill: "#E53170"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2716 9.1001H5.56429C5.19116 9.1001 4.88867 9.40243 4.88867 9.77537C4.88867 10.1483 5.19116 10.4506 5.56429 10.4506H11.2716C11.6447 10.4506 11.9472 10.1483 11.9472 9.77537C11.9472 9.40243 11.6447 9.1001 11.2716 9.1001Z",
  fill: "#F25F4C"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3207 6.77783H6.49423C6.10208 6.77783 5.78418 7.09573 5.78418 7.48789C5.78418 7.88004 6.10208 8.19794 6.49423 8.19794H10.3207C10.7128 8.19794 11.0307 7.88004 11.0307 7.48789C11.0307 7.09573 10.7128 6.77783 10.3207 6.77783Z",
  fill: "#F25F4C"
});

function SvgUicoachLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUicoachLogo);
export default __webpack_public_path__ + "static/media/uicoach-logo.8d008a21.svg";
export { ForwardRef as ReactComponent };